import { atom } from 'jotai';

export type GuardedRouteAtom = {
	href: string;
};

// An atom to store the guarded route so it can be later replaced if credential is granted
export const guardedRouteAtom = atom<GuardedRouteAtom | null>(null);
